<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ !edit ? $t('absences.do_demand') : $t('absences.edit_do_demand') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>

          <div class="modal-body overflow-auto">
            <RequiredText />
            <Select2
              container-class="form-group mt-5"
              :multiple="false"
              :show-search="true"
              :selectClass="'form-select form-control-sm form-select-solid'"
              :name="'type_absence'+id"
              :label="$t('absences.type_absence')"
              labelClass="form-label fs-6 text-black"
              :placeholder-text="$t('absences.type_absence')"
              v-model="formData.holiday_type_id"
              :isRequired="false" 
              >
              <option v-for="absenceType in absenceTypes" :value="absenceType.id" :key="absenceType.id">
                {{ absenceType.name }}
              </option>
            </Select2>

            <div v-if="holidayTypeSelected">
              <div v-for="(date, index) in formData.dates" :key="index">
                <div class="row mb-3">
                  <InputDate
                    :name="'start_date'+index+id"
                    type="text"
                    :label="$t('absences.start_date')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-sm form-control-solid'"
                    :isRequired="false" 
                    size="lg"
                    :placeholder="$t('absences.start_date')"
                    v-model="date.start_date"
                    :maxDate="max_datetime(index)"
                    :containerClass="holidayTypeConfig?.type_under_stock == 'Totaly' ? 'mt-5 form-group mb-5 col-12 col-md-12 col-lg-12' : (holidayTypeConfig?.type_stock !== 'None' && holiday_remaining_number > 0) ? 'mt-5 form-group mb-5 col-12 col-md-5 col-lg-5' : 'mt-5 form-group mb-5 col-12 col-md-6 col-lg-6'"
                  />
                  <InputDate
                    containerClass="mt-5 form-group mb-5 col-12 col-md-6 col-lg-6"
                    :name="'end_date'+index+id"
                    type="text"
                    :label="$t('absences.end_date')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-sm form-control-solid'"
                    :isRequired="false" 
                    size="lg"
                    :placeholder="$t('absences.end_date')"
                    v-model="date.end_date"
                    v-if="holidayTypeConfig?.type_under_stock !== 'Totaly'"
                    :minDate="date.start_date"
                  />
                  <div class="col-12 col-md-1 col-lg-1 mt-5 d-flex justify-content-center align-items-center" v-if="(holidayTypeConfig?.type_stock !== 'None' && holidayTypeConfig?.type_under_stock !== 'Totaly')  && holiday_remaining_number > 0">
                    <a class="btn btn-sm btn-icon btn-danger p-5" @click="removeItem(index)">
                      <i class="bi bi-trash-fill fs-5"></i>
                    </a>
                  </div>
                </div>
                <span v-if="holidayTypeConfig?.type_under_stock !== 'Totaly' && date.start_date !== ''" > {{ $t('absences.count')}} : {{date.nbrDay}}</span>
              </div>
              <div class="d-block text-end" v-if="holidayTypeConfig?.type_under_stock !== 'Totaly'  && holiday_remaining_number > 0">
                <a class="btn btn-primary" @click="addItem">
                  {{ $t('button.add') }}
                </a>
              </div>

              <div v-if="holidayTypeSelected !== '' && holidayTypeConfig?.type_stock !== 'None'">
                <div v-if="holidayTypeSelected && holidayTypeStock && holiday_remaining_number >=0 && holidayTypeStock == holiday_remaining_number" class="bg-input-primary text-primary border-rounded mt-5 p-5 d-flex align-items-center" style="border-radius: 5px;">
                  <i class="fas fa-exclamation-circle me-3 fs-2 text-primary"></i> 
                  {{ $t('absences.you_have') }} {{ holiday_remaining_number }} {{ $t('absences.days') }} {{ (holiday_remaining_number >= 28) ? ($t('absences.whether') + ' ' + (holiday_remaining_number / 28).toFixed(1) + ' ' +  $t('absences.months')) : '' }} {{$t('absences.of_absence')}}
                </div>
                <div v-if="holidayTypeSelected && holidayTypeStock && holiday_remaining_number >= 0 && holidayTypeStock > holiday_remaining_number && holidayTypeConfig?.type_under_stock !== 'Totaly'" class="bg-input-warning text-warning border-rounded mt-5 p-5 d-flex align-items-center" style="border-radius: 5px;">
                  <i class="fas fa-exclamation-circle me-3 fs-2 text-warning"></i> 
                  {{ $t('absences.you_will_have') }} {{ holiday_remaining_number }}  {{ $t('absences.available_days_text') }}
                </div>
                <div v-if="holidayTypeStock  && holiday_remaining_number < 0" class="bg-input-danger text-danger border-rounded mt-5 p-5 d-flex align-items-center" style="border-radius: 5px;">
                  <i class="fas fa-exclamation-circle me-3 fs-2 text-danger"></i> 
                  {{ $t('absences.request_number_superior') }}
                </div>
                <div v-if="holidayTypeSelected && holidayTypeStock == 0  && holiday_remaining_number == 0" class="bg-input-warning text-warning border-rounded mt-5 p-5 d-flex align-items-center" style="border-radius: 5px;">
                  <i class="fas fa-exclamation-circle me-3 fs-2 text-warning"></i> 
                  {{ $t('absences.request_not_more_authorized') }}
                </div>
              </div>
            </div>
            <div class="form-group mt-5">
              <label class="required form-label fs-6 text-black">{{ $t('absences.description') }}</label>
              <textarea v-model="formData.description" :name="'description'+id" class="form-control form-control-solid" rows="3" required></textarea>
            </div>
            <div class="mt-5">
              <label class="form-label fs-6 text-black" :class="holidayTypeConfig?.attachment ? 'required' : ''"> {{ $t('absences.add_file') }} </label>
              <DropFileZone
                :id="`absence_file_upload_${id}`"
                :files="formData.attach_files"
                @addFiles="addFiles"
                @removeFiles="removeFiles"
              />
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" @click="closeModal" :id="id+'_cancel_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel"></Button>
            <Button btn-class="btn-sm me-3" type="submit" :id="id+'_submit_btn'" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import {ref, defineProps, onMounted, watch, nextTick, defineEmits, computed, watchEffect} from 'vue'
import {useStore} from "vuex";
import Button from "@/components/Button.vue"
import RequiredText from "@/components/RequiredText";
import InputDate from "@/components/InputDate.vue";
import Select2 from "@/components/Select2.vue";
import DropFileZone from "@/components/DropFileZone.vue";

const emits = defineEmits(['load'])

const props = defineProps({
    id: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      default: {
        id: '',
        holiday_type_id: '',
        description: "",
        dates: [
          {
            start_date: "",
            end_date: "",
            nbrDay: 0
          }
        ],
        files: [],
        attach_files: [],
        detach_files: []
      }
    },
    nbrHolidays: {
      type: Number,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    },
    dates: {
      type: Object,
      default: {}
    },
})

const store = useStore()
const formData = ref(props.form)
const isLoading = ref(false)

const holidayTypeConfig = ref({})
const holidayTypeStock = ref(0)

const absenceTypes = computed(() => store.getters['absence_types/getAbsenceTypes'])
const userCountryWorkdaysList = computed(() => store.getters['absences/userCountryWorkdaysList'])
const userCountryPublicHolidaysList = computed(() => store.getters['absences/userCountryPublicHolidaysList'])

const holidayTypeSelected = computed(() => formData.value.holiday_type_id || null)
const holiday_remaining_number = computed(() => {
  if (!Array.isArray(formData.value.dates)) return parseInt(holidayTypeStock.value);

  let totalNbrDay = formData.value.dates.reduce((sum, date) => {
    return sum + (date.nbrDay && !isNaN(date.nbrDay) ? Number(date.nbrDay) : 0);
  }, 0);
  return parseInt(holidayTypeStock.value) - totalNbrDay;
});


watch(() => holidayTypeSelected.value, async(value) => {
  if(value){
    await store.dispatch('absence_types/getUserCountryHolidayTypeManagement', value).then((res) => {
      holidayTypeConfig.value = res.data.holiday_type_management
      getHolidayTypeStock()
    }) 
  }else{
    holidayTypeConfig.value = {}
    holidayTypeStock.value = 0
  }
}, { deep: true })

watchEffect(() => {
  formData.value.dates?.forEach((x, key) => {
    if (x.start_date || x.end_date) {
      numberHolidayBetweenDate(x.start_date, x.end_date, key);
    }
  });
})

function closeModal(){
  $('#'+props.id).modal('toggle')
}

function addItem() {
  formData.value.dates.push({
    start_date: "",
    end_date: "",
    nbrDay: 0
  })
}

function removeItem(index) {
  if(formData.value.dates.length > 1) {
    formData.value.dates.splice(index, 1)
  }
}

function addFiles(files){
    for(let file of files) {
        formData.value.files.push(file)
        formData.value.attach_files.push(file)
    }
}

function removeFiles(index) {
    const fileToDelete = formData.value.attach_files.splice(index, 1)
    formData.value.detach_files?.push(fileToDelete[0]?.id)
    formData.value.files.splice(index, 1)
}

function pad(s) {
  return (s < 10) ? '0' + s : s;
}

function convertDate(d) {
  return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate()),].join('-')
}

function getDatesInRange(startDate, endDate) {
  let dates = [];
  let currentDate = new Date(startDate);

  while (currentDate <= new Date(endDate)) {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');

    dates.push(`${year}-${month}-${day}`);

    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
}

function getDayName(date = new Date(), locale = 'en-US') {
  date = moment(date, "YYYY-MM-DD").format("YYYY-MM-DD")
  return new Date(date).toLocaleDateString(locale, {weekday: 'long'});
}

function getHolidayTypeStock(){
  if(holidayTypeConfig.value?.type_stock == 'Fixed'){
    holidayTypeStock.value = holidayTypeConfig.value?.stock
  }

  if(holidayTypeConfig.value?.type_stock == 'Yearly' && holidayTypeConfig.value?.stock == 24){
    holidayTypeStock.value = props.nbrHolidays || 0
  }

  if(holidayTypeConfig.value?.type_stock !== 'Fixed' && holidayTypeConfig.value?.type_stock !== 'None' || holidayTypeConfig.value?.type_under_stock == 'Partially' || holidayTypeConfig.value?.type_under_stock == 'Both'){
      if((holidayTypeConfig.value && holidayTypeConfig.value?.type_stock !== 'Monthly' && holidayTypeConfig.value?.type_stock !== 'None')
          && !(holidayTypeConfig.value?.type_stock == 'Yearly' && holidayTypeConfig.value?.stock == 24)){
          holidayTypeStock.value = holidayTypeConfig.value?.stock
      }
  }
}

async function numberHolidayBetweenDate (start, end, key) {
  const oldStart = props.dates?.start_date;
  const oldEnd = props.dates?.end_date;

  if (props.edit && formData.value.dates[key].nbrDay && oldStart === start && oldEnd === end) {
    return;
  }
  formData.value.dates[key].nbrDay = 0
  start = moment(start, "DD-MM-YYYY").format("YYYY-MM-DD");

  if (start !== '') {
    if (end === '') {
      if (holidayTypeConfig.value?.type_stock === 'Totaly') {
        if (holidayTypeConfig.value?.include_day_off) {
          const dateFns = require('date-fns');
          let y = dateFns.addDays(new Date(start), holiday_remaining_number.value - 1);
          end = moment(y).format("YYYY-MM-DD");
        } else {
          formData.value.dates[key].nbrDay = holiday_remaining_number.value;
          return;
        }
      }
    } else {
      end = moment(end, "DD-MM-YYYY").format("YYYY-MM-DD");
    }

    let dates = getDatesInRange(new Date(start), new Date(end));

    if (holidayTypeConfig.value?.type_under_stock !== 'Totaly') {
      if (holidayTypeConfig.value?.include_day_off) {
        let public_holidays = userCountryPublicHolidaysList.value.flatMap(y => [y.start_date, y.end_date]);
        public_holidays = [...new Set(public_holidays)];

        let diff_public_holidays = dates.filter(x => !public_holidays.includes(x));
        let date_workdays = diff_public_holidays.filter(y => userCountryWorkdaysList.value.includes(getDayName(y)));

        formData.value.dates[key].nbrDay = date_workdays.length;
      } else {
        formData.value.dates[key].nbrDay = dates.length;
      }
    }

    if (end === '') {
      formData.value.dates[key].end_date = end;
    }
  }
  return formData.value.dates[key].nbrDay
}

function max_datetime(key) {
  let date = ''

  if(key == 0 && holidayTypeConfig.value?.allow_previous_date){
    date = convertDate(new Date())
  }

  return date
}

function submitForm(){
  isLoading.value = true
  let action = props.edit ? 'absences/updateAbsence' : 'absences/createAbsence'
  let message = props.edit ? 'absences.absence_updated_successfully' : 'absences.absence_created_successfully'

  store.dispatch(action, formData.value)
      .then((response) => {
          isLoading.value = false
          emits('load')
          closeModal()
          formData.value.id= '',
          formData.value.holiday_type_id= '',
          formData.value.description= '',
          formData.value.dates= [{
            start_date: "",
            end_date: "",
            nbrDay: 0
          }],
          formData.value.files= []
          holidayTypeSelected.value = null

          window.toastr['success'](i18n.global.t(message))
      })
      .catch(err => {
          isLoading.value = false
      })
}

onMounted(async() => {
  await store.dispatch('absence_types/loadAbsenceTypes') 
  await store.dispatch('absences/getUserCountryWorkdays') 
  await store.dispatch('absences/getUserCountryPublicHolidays') 
})
</script>

<style>
  .bg-input-warning {
    background-color: #F0781733 !important;
  }
  .bg-input-primary {
    background-color: #f1faff !important;
  }
  .bg-input-danger {
    background-color: #FFF5F8 !important;
  }
</style>